import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import {
  newCheckInAction,
  newNextAction,
  newRandomNextAction,
  NEW_NEXT,
  RANDOM_NEXT,
} from '../../actions/navigation';

import Transition from '../../components/Transition';
import ContentWrapper from '../../components/ContentWrapper';
import Header from '../../components/Header';
import Modal from '../../components/Modal';
import { parseUrlParams, addLusaHeaderParam } from '../../utils/parseUrlParams';
import { useConfig } from '../../config/ConfigContext';
import imgError from '../../assets/images/error.svg';
import './style.scss';

const Microbilt = (props) => {
  const config = useConfig();
  const [microbiltHeight, setMicrobiltHeight] = useState(0);
  const [isConsentModalVisible, setIsConsentModalVisible] = useState(true);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const microbiltContainerRef = useRef(null);
  const params = parseUrlParams(window.location.search);
  const { fetch, navigate, checkinData } = props;

  useEffect(() => {
    const onMessageReceived = (event) => {
      const { data } = event;
      if (data.microbiltComplete) {
        if (params.key) {
          props.newNextAction({
            key: params.key,
            workflowType: 'microbilt',
            data: {},
            fail: (err) => {
              console.log(err);
              setIsPopupVisible(true);
            },
          });
        }
      }
    };

    if (isEmpty(checkinData)) {
      props.newCheckInAction({
        workflowType: 'microbilt',
        key: params.key,
        success: (res) => {
          let routeUrl = get(res, 'data.url');
          if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
            routeUrl = addLusaHeaderParam(routeUrl);
          }
          navigate(routeUrl);
        },
      });
    } else if (microbiltHeight === 0) {
      setMicrobiltHeight(microbiltContainerRef.current.clientHeight - 50);
    }

    window.addEventListener('message', onMessageReceived, false);
    return () => {
      window.removeEventListener('message', onMessageReceived, false);
    };
  }, []);

  useEffect(() => {
    if (!get(checkinData, 'data.data.returnUrl', get(checkinData, 'state.data.returnUrl'))) {
      let routeUrl = get(checkinData, 'data.url') || get(checkinData, 'state.url');
      if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
        routeUrl = addLusaHeaderParam(routeUrl.replace(config.hostUrl, ''));
      }
      if (fetch.isDone[`${RANDOM_NEXT}`] && !fetch.isRunning[`${RANDOM_NEXT}`]) {
        if (
          get(checkinData, 'data.data.nextAction.path')
          || get(checkinData, 'state.data.nextAction.path')
        ) {
          props.newRandomNextAction({
            rawUrl: get(checkinData, 'data.data.nextAction.path') || get(checkinData, 'state.data.nextAction.path'),
            data: {},
          });
        } else if (get(checkinData, 'data.nextAction.path') || get(checkinData, 'state.nextAction.path')) {
          props.newRandomNextAction({
            rawUrl: get(checkinData, 'data.nextAction.path') || get(checkinData, 'state.nextAction.path'),
            data: {},
          });
        } else if (routeUrl) {
          navigate(routeUrl);
        }
      } else if (
        fetch.isDone[`${NEW_NEXT}`]
        && !fetch.isRunning[`${NEW_NEXT}`]
      ) {
        if (
          get(checkinData, 'data.data.nextAction.path')
          || get(checkinData, 'state.data.nextAction.path')
        ) {
          props.newRandomNextAction({
            rawUrl: get(checkinData, 'data.data.nextAction.path') || get(checkinData, 'state.data.nextAction.path'),
            data: {},
          });
        } else if (get(checkinData, 'data.nextAction.path') || get(checkinData, 'state.nextAction.path')) {
          props.newRandomNextAction({
            rawUrl: get(checkinData, 'data.nextAction.path') || get(checkinData, 'state.nextAction.path'),
            data: {},
          });
        } else if (routeUrl) {
          navigate(routeUrl);
        }
      }
    }
  }, [checkinData]);

  const handleAgreeButtonClick = (e) => {
    e.preventDefault();
    setIsConsentModalVisible(false);
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };

  const handleVerifyLater = () => {
    if (params.key) {
      props.newNextAction({
        key: params.key,
        workflowType: 'microbilt',
        data: {
          skip: true,
        },
        fail: (err) => {
          console.log(err);
          setIsPopupVisible(true);
        },
      });
    }
  };

  return (
    <Transition className="transition-item wrapper vh-100">
      <Header />
      <ContentWrapper className="mh-20 microbilt-wrapper">
        <div className="microbilt-container container" ref={microbiltContainerRef}>
          <div className="verifyManual" onClick={handleVerifyLater}>Verify Manually</div>
          {
            (checkinData.data || checkinData.state) && (
              <iframe
                title="microbilt verification"
                src={`${get(checkinData, 'data.data.microBiltUrl') || get(checkinData, 'state.data.microBiltUrl')}`}
                width="100%"
                height={microbiltHeight}
                frameBorder="0"
                style={{ overflow: 'hidden' }}
              />
            )
          }
        </div>
      </ContentWrapper>
      {
        isConsentModalVisible && (
          <Modal>
            <div className="card-header">
              { // eslint-disable-next-line jsx-a11y/control-has-associated-label
                <button type="button" className="close" onClick={handleAgreeButtonClick} />
              }
              <h5>Income Verification</h5>
            </div>
            <div className="card-content error-modal">
              <p className="sub-title mb-1">LendingUSA uses Microbilt to verify your income.</p>
              <h2 className="text-center mb-3 popup-content">
                Please select ALL bank institutions and bank accounts that contain your income deposits.
              </h2>
              <div onClick={handleAgreeButtonClick} className="btn btn-green">Continue</div>
            </div>
          </Modal>
        )
      }
      {
        isPopupVisible && (
          <Modal>
            <div className="card-content error-modal security-error">
              <img src={imgError} alt="" />
              <p>Please try again.</p>
              <div onClick={handleClosePopup} className="btn btn-red">OK</div>
            </div>
          </Modal>
        )
      }
    </Transition>
  );
};

Microbilt.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  fetch: PropTypes.object.isRequired,
  newCheckInAction: PropTypes.func.isRequired,
  newNextAction: PropTypes.func.isRequired,
  newRandomNextAction: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

const mapDispatchToProps = {
  newCheckInAction,
  newNextAction,
  newRandomNextAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Microbilt);
